
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.763 14H18V2H2v13.385L3.763 14zm.692 2L0 19.5V1a1 1 0 011-1h18a1 1 0 011 1v14a1 1 0 01-1 1H4.455zM9 11h2v2H9v-2zM6.567 5.813A3.5 3.5 0 1110 10H9V8h1a1.5 1.5 0 10-1.471-1.794l-1.962-.393z","fill":"#FAAD14"}})])
          )
        }
      }
    